import axios from "axios";
import { REFRESH_TOKEN_KEY, TOKEN_KEY } from "./constants";

export const parseJwt = <T>(token: string): T => {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(c => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join("")
  );

  return JSON.parse(jsonPayload);
};

export const refreshToken = async (): Promise<void> => {
  const token = localStorage.getItem(REFRESH_TOKEN_KEY);
  if (!token) {
    throw new Error("No refresh token found");
  }
  // Use fetch instead of axios to avoid infinite loop with interceptors
  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/refresh-token/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ refresh: token }),
  });
  if (!response.ok) {
    if (response.status === 401) {
      localStorage.removeItem(REFRESH_TOKEN_KEY);
      localStorage.removeItem(TOKEN_KEY);
      throw new Error("Unauthorized");
    }
    throw new Error(`Error in request: ${response.status}`);
  }
  const decoded = await response.json();
  localStorage.setItem(TOKEN_KEY, decoded.access);
  axios.defaults.headers.common.Authorization = `Bearer ${decoded.access}`;
};
